/* eslint-disable react-hooks/exhaustive-deps */
import { IoMdSearch } from "react-icons/io";
import { useEffect, useState } from "react";
import { MdRefresh } from "react-icons/md";
import Swal from "sweetalert2";

import PieChartDouble from "../../components/Grafik/PieChartDouble";
import PieChart from "../../components/Grafik/PieChart";
import DataSIM from "../../components/Card/data.sim";
import { API_URL_AUTH, API_URL_PAY } from "../../config";
import LoadingSpinner from "../../components/Loading/loading";
import { FaSpinner } from "react-icons/fa";
import api from "../../config/api";

const SIM = () => {
  const [loading, setLoading] = useState(true);

  const today = new Date();

  const formatDate = (date) => {
    const pad = (num) => num.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}`;
  };

  const [dataOutlet, setDataOutlet] = useState();
  const [total, setTotal] = useState();
  const [selectOutlet, setSelectOutlet] = useState();
  const [dataDuo, setDataDuo] = useState([]);
  const [dataA, setDataA] = useState([]);
  const [dataB, setDataB] = useState([]);
  const [dataC, setDataC] = useState([]);
  const [dataD, setDataD] = useState([]);

  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(today));

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true); // mulai loading
      try {
        await Promise.all([
          getDataOutlet(),
          getDataDuo(),
          getData(),
          getDataJumlah(),
        ]);
      } catch (error) {
        console.log("error load:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  const handleSearch = async () => {
    setLoading(true);
    try {
      await Promise.all([getDataJumlah(), getDataDuo(), getData()]);
    } catch (error) {
      console.log("error search:", error);
    } finally {
      setLoading(false);
    }
  };

  const getDataDuo = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/total-double-sim?outletId=${
          selectOutlet || ""
        }&periode=5&date_first=${new Date(
          startDate
        ).getTime()}&date_second=${new Date(endDate).getTime()}`
      );
      setDataDuo(response.data.data);
    } catch (error) {
      console.log(error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const getData = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/laporan-sim?outletId=${
          selectOutlet || ""
        }&periode=5&date_first=${new Date(
          startDate
        ).getTime()}&date_second=${new Date(endDate).getTime()}`
      );
      setDataA(response.data.data.A);
      setDataB(response.data.data.B);
      setDataC(response.data.data.C);
      setDataD(response.data.data.D);
    } catch (error) {
      console.log(error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const getDataJumlah = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?outletId=${
          selectOutlet || ""
        }&periode=5&date_first=${new Date(
          startDate
        ).getTime()}&date_second=${new Date(endDate).getTime()}`
      );
      setTotal(response.data.total);
      console.log("berhasil load total");
    } catch (error) {
      console.log(error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const getDataOutlet = async () => {
    try {
      const response = await api.get(`${API_URL_AUTH}/mopsimapp/all-outlet`);
      setDataOutlet(response.data.data);
      console.log("berhasil load total");
    } catch (error) {
      console.log(error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  return (
    <>
      <div className="min-h-screen h-full p-4 bg-gradient-to-b from-gray-300 to-teal-800">
        <h1 className="font-bold text-xl md:text-2xl mb-4 text-amber-700">
          Rekap Data Laporan SIM
        </h1>
        <div className="flex flex-col md:flex-row w-full gap-2 field-body mb-4">
          <div className="w-full">
            <label htmlFor="start-date">Dari Tanggal</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="input is-small w-full border-1 border-secondary hover:border-secondary/90 rounded-lg bg-gray-200"
            />
          </div>
          <div className="w-full">
            <label htmlFor="end-date">Sampai Tanggal</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate}
              className="input is-small w-full hover:border-secondary/90 rounded-lg bg-gray-200"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row w-full gap-2 field-body mb-4">
          <div className="w-full">
            <label htmlFor="outlet">Outlet</label>
            <select
              value={selectOutlet}
              onChange={(e) => setSelectOutlet(e.target.value)}
              className="input is-small w-full hover:border-secondary/90 rounded-lg bg-gray-200"
            >
              <option value="">Pilih Outlet</option>
              {dataOutlet &&
                dataOutlet.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.namaOutlet}
                  </option>
                ))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-2 md:w-[500px]">
            <button
              onClick={() => handleSearch()}
              disabled={loading}
              className={`btn md:mt-6 px-2 py-1 rounded-lg flex justify-center items-center gap-2 
                bg-gradient-to-b from-gray-600 to-teal-800 text-white hover:scale-95
                ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              {loading ? (
                <>
                  <FaSpinner className="animate-spin" color="light" />
                  Loading
                </>
              ) : (
                <>
                  <IoMdSearch /> Cari
                </>
              )}
            </button>
            <button
              onClick={() => window.location.reload()}
              className="btn md:mt-6 px-2 py-1 md:order-last rounded-lg flex justify-center items-center gap-2 bg-amber-700 text-white hover:scale-95"
            >
              <MdRefresh /> Refresh
            </button>
          </div>
        </div>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="grid grid-cols-1 gap-4">
              <DataSIM total={total} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <PieChart data={dataA} Jenis="SIM A" />
              <PieChart data={dataB} Jenis="SIM B" />
              <PieChart data={dataC} Jenis="SIM C" />
            </div>
            {/* tes */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <PieChart data={dataD} Jenis="SIM D" />
              <PieChartDouble data={dataDuo} Jenis="SIM AC & BC" />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SIM;
